import * as React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useRouter } from "next/navigation";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CtaButton from "../buttonWithArrow";
import Heading from "../heading";

const MAX_W = 1300;  // Section content cap
const IMG_W = 1300;  // Max width for the illustration

export default function ServiceCategories({ data, onClick }) {
    const { title, subtitle, button, services, bgcolor } = data;
    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 4 },
                px: { xs: 2, sm: 3 },
                bgcolor: bgcolor ?? "#f7f9f9",
            }}
        >
            {/* Header */}
            <Heading title={title} subtitle={subtitle} mb={7} />

            {/* Service Grid */}
            <Box sx={{ maxWidth: MAX_W, mx: "auto" }}>
                <Grid container spacing={3} justifyContent="center">
                    {services?.map((service, i) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                            <ServiceCard
                                image={service?.image}
                                title={service?.name}
                                redirectUrl={service?.href}
                            />
                        </Grid>
                    ))}
                </Grid>

                {/* CTA */}
                {button && (
                    <Box sx={{ mt: 5, textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                        <CtaButton label={button?.text} href={button?.href} />
                    </Box>
                )}
            </Box>
        </Box>
    );
}

function ServiceCard({ image, title, redirectUrl }) {
    const router = useRouter();

    return (
        <Box
            sx={{
                borderRadius: 4,
                overflow: 'hidden',
                padding: 3,
                textAlign: 'center',
                backgroundColor: "white",
                border: "3px solid #000",
                borderRadius: "42px",
                boxShadow: "4px 4px 0px rgb(48 152 166)",
                transition: 'transform 0.3s ease',
                '&:hover': {
                    transform: 'scale(1.05)',
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer"
            }}
        >
            {/* Image Section */}
            <Box sx={{ position: 'relative', height: 80 }}>
                <img
                    src={image} // dynamic image URL
                    alt={title}
                    width={60}
                    height={60}
                    style={{ objectFit: 'contain' }}
                />
            </Box>

            {/* Title */}
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    mb: 1,
                    fontSize: '22px',
                    lineHeight: '1.4',             // Control the line height for readability
                    color: 'inherit',              // Inherit text color from parent (if any)
                }}
            >
                {title} {/* Dynamic title */}
            </Typography>



            {/* Button */}
            <Button
                variant="text"
                sx={{
                    background: 'none', // Remove the default background
                    color: 'transparent', // Make the text color transparent so that the gradient is visible
                    backgroundImage: 'linear-gradient(to right, #75C4C5, #0D8196)', // Apply the gradient to text
                    WebkitBackgroundClip: 'text', // Clip the background to the text
                    fontWeight: 700,
                    fontSize: "20px",
                    display: 'flex',
                    alignItems: 'center',
                    '&:hover': {
                        bgcolor: 'transparent', // Remove background on hover to keep gradient effect
                        textDecoration: 'underline', // Optional: Add underline effect on hover for emphasis
                    },
                    textTransform: 'none', // Optional: Prevents the text from being uppercase (if you prefer)
                }}
                onClick={() => router.push(redirectUrl)}
            >
                Book Now
                <ArrowForwardIosIcon
                    sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: '#6cbec1'
                    }}
                />
            </Button>


        </Box>
    );
}
